<template>
  <footer class="border-t border-navy-100 bg-white">
    <div class="mx-auto grid max-w-7xl gap-10 px-5 py-14 md:grid-cols-[1.4fr_1fr_1fr] lg:px-8">
      <div>
        <img src="../assets/mclogo.webp" alt="MCLEANIT Ltd" class="h-14 w-auto" />
        <p class="mt-5 max-w-sm text-sm leading-7 text-navy-600">
          Exterior cleaning for homes and businesses in Bishop's Stortford and the surrounding area, covering
          roofs, render, gutters, windows, driveways and more. Fully insured, free quotes.
        </p>
        <div class="mt-6 flex items-center gap-3">
          <a
            v-for="social in socials"
            :key="social.label"
            :href="social.href"
            target="_blank"
            rel="noreferrer"
            :aria-label="social.label"
            class="flex h-10 w-10 items-center justify-center rounded-full bg-white text-navy-700 ring-1 ring-navy-100 transition hover:bg-navy-900 hover:text-white"
          >
            <i :class="social.icon"></i>
          </a>
        </div>
      </div>

      <div>
        <h2 class="text-xs font-semibold uppercase tracking-[0.18em] text-navy-500">Explore</h2>
        <ul class="mt-5 space-y-3 text-sm font-medium text-navy-700">
          <li v-for="link in links" :key="link.href">
            <a :href="link.href" class="transition hover:text-navy-950">{{ link.label }}</a>
          </li>
        </ul>
      </div>

      <div>
        <h2 class="text-xs font-semibold uppercase tracking-[0.18em] text-navy-500">Get in touch</h2>
        <ul class="mt-5 space-y-3 text-sm font-medium text-navy-700">
          <li><a href="tel:+447534490921" class="transition hover:text-navy-950">07534 490921</a></li>
          <li><a href="mailto:mcleanit@mail.com" class="transition hover:text-navy-950">mcleanit@mail.com</a></li>
        </ul>
        <a href="#contact" class="btn-primary mt-6 !px-6 !py-3">Get a free quote</a>
      </div>
    </div>

    <div class="border-t border-navy-100">
      <div class="mx-auto max-w-7xl px-5 py-6 text-xs text-navy-500 lg:px-8">
        © {{ year }} MCLEANIT Ltd. All rights reserved.
      </div>
    </div>
  </footer>
</template>

<script setup>
const year = new Date().getFullYear()

const links = [
  { href: '#services', label: 'Services' },
  { href: '#work', label: 'Our work' },
  { href: '#process', label: 'How it works' },
  { href: '#contact', label: 'Contact' }
]

const socials = [
  { icon: 'fab fa-instagram', label: 'Instagram', href: 'https://www.instagram.com/mcleanitltd/' },
  { icon: 'fab fa-facebook', label: 'Facebook', href: 'https://facebook.com/georgemcl94' }
]
</script>
